import React from "react";

const RedirectIcon = ({ fill = "#4D4D4D", ...props }) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title || ""}</title>
      <path
        d="M7 2.99976V4.99976H2V15.9998H13V10.9998H15V16.9998C15 17.5521 14.5523 17.9998 14 17.9998H1C0.44772 17.9998 0 17.5521 0 16.9998V3.99976C0 3.44748 0.44772 2.99976 1 2.99976H7ZM18 -0.000244141V7.99976H16L15.9999 3.41276L8.2071 11.2069L6.79289 9.79266L14.5849 1.99976H10V-0.000244141H18Z"
        fill={fill}
      />
    </svg>
  );
};

export default RedirectIcon;
